import type { IDashboardTemplate } from "../types";
import { EFamilyTypes } from "../components/DashboardTemplatesTypes";
import { AssetsService } from "../../../../services/AssetsService";

const dashboard: IDashboardTemplate = {
    id: 6,
    title: "dashboard.templates.dailycompetitiveanalysis.title",
    description: "dashboard.templates.dailycompetitiveanalysis.description",
    descriptionLong: "dashboard.templates.dailycompetitiveanalysis.description.long",
    keyMetrics: "dashboard.templates.dailycompetitiveanalysis.keymetric",
    previewImage: AssetsService.assetUrl("/images/dashboard/templates/DailyCompetitiveOverview-preview.png"),
    thumbnailImage: AssetsService.assetUrl("/images/dashboard/templates/DailyCompetitiveOverview-thumb.png"),
    familyType: EFamilyTypes.Website,
    autoFillUserDomain: true,
    minItems: 2,
    maxItems: 5,
    widgets: [
        {
            pos: {
                sizeX: 4,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 0,
                col: 0,
            },
            properties: {
                selectedChannel: "Direct",
                metric: "EngagementVisits",
                webSource: "Total",
                duration: "28d",
                type: "Graph",
                filters: {
                    ShouldGetVerifiedData: true,
                    includeSubDomains: "true",
                    timeGranularity: "Daily",
                },
                width: "2",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Daily Traffic",
                tooltip: "Last Month's Daily Traffic.tooltip",
                titleTemplate: "custom",
            },
        },
        {
            pos: {
                sizeX: 3,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 1,
                col: 0,
            },
            properties: {
                froWebSource: "Total",
                selectedChannel: "Direct",
                metric: "EngagementVisits",
                webSource: "Desktop",
                duration: "28d",
                type: "Graph",
                filters: {
                    ShouldGetVerifiedData: "true",
                    timeGranularity: "Daily",
                    includeSubDomains: "true",
                },
                width: "2",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Desktop | Daily Visits",
                tooltip: "Desktop | Visits.tooltip",
                titleTemplate: "custom",
            },
        },
        {
            pos: {
                sizeX: 1,
                minSizeX: 1,
                row: 1,
                col: 3,
                maxSizeY: 1,
                maxSizeX: 2,
            },
            properties: {
                froWebSource: "Total",
                selectedChannel: "Direct",
                metric: "EngagementVisits",
                webSource: "Desktop",
                duration: "28d",
                type: "PieChart",
                filters: {
                    ShouldGetVerifiedData: "true",
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "1",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Desktop Split",
                tooltip: "Desktop.tooltip",
                titleTemplate: "custom",
            },
        },
        {
            pos: {
                sizeX: 3,
                minSizeX: 2,
                row: 2,
                col: 0,
                maxSizeY: 2,
                maxSizeX: 4,
            },
            properties: {
                mobileWebOnly: true,
                selectedChannel: "Direct",
                metric: "EngagementVisits",
                webSource: "MobileWeb",
                duration: "28d",
                type: "Graph",
                filters: {
                    ShouldGetVerifiedData: "true",
                    timeGranularity: "Daily",
                    includeSubDomains: "true",
                },
                width: "2",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Mobile | Daily Visits",
            },
        },
        {
            pos: {
                sizeX: 1,
                sizeY: 1,
                maxSizeY: 1,
                minSizeX: 1,
                maxSizeX: 2,
                row: 2,
                col: 3,
            },
            properties: {
                mobileWebOnly: true,
                selectedChannel: "Direct",
                metric: "EngagementVisits",
                webSource: "MobileWeb",
                duration: "28d",
                type: "PieChart",
                filters: {
                    ShouldGetVerifiedData: "true",
                    timeGranularity: "Monthly",
                    includeSubDomains: "true",
                },
                width: "1",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Mobile Split",
                tooltip: "Mobile.tooltip",
                titleTemplate: "custom",
            },
        },
        {
            pos: {
                sizeX: 2,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 3,
                col: 0,
            },
            properties: {
                selectedChannel: "Direct",
                metric: "EngagementOverview",
                webSource: "Desktop",
                duration: "28d",
                type: "EngagementTableDashboard",
                filters: {
                    ShouldGetVerifiedData: "true",
                    includeSubDomains: "true",
                    timeGranularity: "Daily",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Desktop Engagement Metrics",
                tooltip: "Engagement Metrics.tooltip",
                titleTemplate: "custom",
            },
        },
        {
            pos: {
                sizeX: 2,
                minSizeX: 2,
                row: 3,
                col: 2,
                maxSizeY: 2,
                maxSizeX: 4,
            },
            properties: {
                mobileWebOnly: true,
                selectedChannel: "Direct",
                metric: "EngagementOverview",
                webSource: "MobileWeb",
                duration: "28d",
                type: "EngagementTableDashboard",
                filters: {
                    ShouldGetVerifiedData: "true",
                    includeSubDomains: "true",
                    timeGranularity: "Daily",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Mobile Engagement Metrics",
                tooltip: "Engagement Metrics.tooltip",
                titleTemplate: "custom",
            },
        },
        {
            pos: {
                sizeX: 4,
                minSizeX: 2,
                row: 4,
                col: 0,
                maxSizeY: 2,
                maxSizeX: 4,
            },
            properties: {
                selectedChannel: "Direct",
                metric: "TrafficSourcesOverview",
                webSource: "Desktop",
                duration: "28d",
                type: "BarChart",
                filters: {
                    includeSubDomains: "true",
                    timeGranularity: "Monthly",
                },
                width: "2",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Marketing Mix",
                tooltip: "Channels Overview.tooltip",
                titleTemplate: "custom",
            },
        },
        {
            pos: {
                sizeX: 2,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 5,
                col: 0,
            },
            properties: {
                selectedChannel: "Direct",
                metric: "ChannelsAnalysisByTrafficShare",
                webSource: "Desktop",
                duration: "28d",
                type: "MmxTrafficShareDashboard",
                filters: {
                    includeSubDomains: "true",
                    timeGranularity: "Daily",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Direct",
                tooltip: "Direct.tooltip",
            },
        },
        {
            pos: {
                sizeX: 2,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 5,
                col: 2,
            },
            properties: {
                selectedChannel: "Referrals",
                metric: "ChannelsAnalysisByTrafficShare",
                webSource: "Desktop",
                duration: "28d",
                type: "MmxTrafficShareDashboard",
                filters: {
                    includeSubDomains: "true",
                    timeGranularity: "Daily",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                title: " Referrals",
                tooltip: " Referrals.tooltip",
            },
        },
        {
            pos: {
                sizeX: 2,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 6,
                col: 0,
            },
            properties: {
                selectedChannel: "Paid Search",
                metric: "ChannelsAnalysisByTrafficShare",
                webSource: "Desktop",
                duration: "28d",
                type: "MmxTrafficShareDashboard",
                filters: {
                    includeSubDomains: "true",
                    timeGranularity: "Daily",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                title: " Paid Search",
                tooltip: " Paid Search.tooltip",
            },
        },
        {
            pos: {
                sizeX: 2,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 6,
                col: 2,
            },
            properties: {
                selectedChannel: "Organic Search",
                metric: "ChannelsAnalysisByTrafficShare",
                webSource: "Desktop",
                duration: "28d",
                type: "MmxTrafficShareDashboard",
                filters: {
                    includeSubDomains: "true",
                    timeGranularity: "Daily",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                title: "Organic Search",
                tooltip: "Organic Search.tooltip",
            },
        },
        {
            pos: {
                sizeX: 2,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 7,
                col: 0,
            },
            properties: {
                selectedChannel: "Display Ads",
                metric: "ChannelsAnalysisByTrafficShare",
                webSource: "Desktop",
                duration: "28d",
                type: "MmxTrafficShareDashboard",
                filters: {
                    includeSubDomains: "true",
                    timeGranularity: "Daily",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                title: " Display Ads",
                tooltip: " Display Ads.tooltip",
            },
        },
        {
            pos: {
                sizeX: 2,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 7,
                col: 2,
            },
            properties: {
                selectedChannel: "Social",
                metric: "ChannelsAnalysisByTrafficShare",
                webSource: "Desktop",
                duration: "28d",
                type: "MmxTrafficShareDashboard",
                filters: {
                    includeSubDomains: "true",
                    timeGranularity: "Daily",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                title: " Social",
            },
        },
        {
            pos: {
                sizeX: 2,
                maxSizeY: 2,
                minSizeX: 2,
                maxSizeX: 4,
                row: 8,
                col: 1,
            },
            properties: {
                selectedChannel: "Email",
                metric: "ChannelsAnalysisByTrafficShare",
                webSource: "Desktop",
                duration: "28d",
                type: "MmxTrafficShareDashboard",
                filters: {
                    includeSubDomains: "true",
                    timeGranularity: "Daily",
                },
                width: "4",
                customAsset: false,
                family: "Website",
                options: {},
                title: " Email",
            },
        },
    ],
};

export default dashboard;
